/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const submitWhatsAppVerificationDataSchema = z.object({
	code: z.string(),
})

export type SubmitWhatsAppVerificationDataSchema = z.infer<typeof submitWhatsAppVerificationDataSchema>
